import { FC } from 'react';
import { EmailAgents } from './EmailAgents';
import { EmailAllAgentsWrapperProps } from './EmailAgents.types';
import useEmailAll from './hooks/useEmailAll';

export const EmailAllAgentsWrapper: FC<
    React.PropsWithChildren<EmailAllAgentsWrapperProps>
> = ({
    path,
    searchType,
    location,
    isUserLoggedIn,
    createAlert,
    singleColumnLayout = false,
    successCloseHandler,
    analyticsTaxonomy
}) => {
    const emailAllState = useEmailAll(
        path,
        'search results',
        analyticsTaxonomy
    );

    return (
        <EmailAgents
            searchType={searchType}
            location={location}
            isUserLoggedIn={isUserLoggedIn}
            createAlert={createAlert}
            emailAllState={emailAllState}
            singleColumnLayout={singleColumnLayout}
            successCloseHandler={successCloseHandler}
        />
    );
};
